import gql from 'graphql-tag';

const updateCompanyMutation = gql`
  mutation updateCompany(
    $_id: String!
    $name: String
    $logo: String
    $isPublic: Boolean
    $emailSuffix: String
    $eventsIds: [String!]
    $usersIds: [String!]
    $promotionsIds: [String]
    $leaderboardAvailable: Boolean
    $needsHealthDeclaration: Boolean
    $isPhoneOptional: Boolean
    $competitionMode: Boolean
    $contentEnabled: Boolean
    $whatsappLink: String
    $slackLink: String
    $sites: [String]
    $minCancellationHours: Float
    $cancellationCustomMessage: String
    $isIdRequired: Boolean
    $allow_gym_subscription: Boolean
    $healthStatementPopupText: String
    $resubmitHealthStatement: Boolean
    $minLockHours: Float
    $cancellationChargeMessage: String
  ) {
    updateCompany(
      _id: $_id
      name: $name
      logo: $logo
      isPublic: $isPublic
      emailSuffix: $emailSuffix
      eventsIds: $eventsIds
      needsHealthDeclaration: $needsHealthDeclaration
      usersIds: $usersIds
      promotionsIds: $promotionsIds
      leaderboardAvailable: $leaderboardAvailable
      isPhoneOptional: $isPhoneOptional
      competitionMode: $competitionMode
      contentEnabled: $contentEnabled
      whatsappLink: $whatsappLink
      slackLink: $slackLink
      sites: $sites
      minCancellationHours: $minCancellationHours
      cancellationCustomMessage: $cancellationCustomMessage
      isIdRequired: $isIdRequired
      allow_gym_subscription: $allow_gym_subscription
      healthStatementPopupText: $healthStatementPopupText
      resubmitHealthStatement: $resubmitHealthStatement
      minLockHours: $minLockHours
      cancellationChargeMessage: $cancellationChargeMessage
    ) {
      _id
      name
      emailSuffix
      whatsappLink
      slackLink
      logo
      isPublic
      leaderboardAvailable
      competitionMode
      contentEnabled
      needsHealthDeclaration
      isPhoneOptional
      sites
      minCancellationHours
      cancellationCustomMessage
      cancellationChargeMessage
      minLockHours
      isIdRequired
      allow_gym_subscription
      lastHealthStatementResubmitAt
      healthStatementPopupText
      events {
        _id
        title
      }
      promotions {
        _id
        title
      }
      users {
        _id
        firstName
        lastName
      }
    }
  }
`;

export default updateCompanyMutation;
